import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [tema, setTema] = useState("tema-a"); // começa no A

  useEffect(() => {
    const salvo = localStorage.getItem("mamute_tema");
    if (salvo) setTema(salvo);
  }, []);

  const alterarTema = (novoTema) => {
    setTema(novoTema);
    localStorage.setItem("mamute_tema", novoTema);
  };

  return (
    <ThemeContext.Provider value={{ tema, alterarTema }}>
      <div className={tema}>{children}</div>
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
